import React from 'react'
import { Page } from '../../components'
import LoginService from '../../services/LoginService'
import LoginCpf from './LoginCpf'
import LoginCustomer from './LoginCustomer'
import '../../assets/styles/css/login.css'

class Login extends React.PureComponent {
    state = {}

    get loginService() {
        if (!this._loginService) {
            this._loginService = new LoginService(this.props)
        }
        return this._loginService
    }

    login = async ({ matricula, password }) => {
        try {
            const code = matricula.replace(/[0-9]/g, '').toUpperCase()
            const matNumber = matricula.replace(/[^0-9]/g, '')
            const filial = this.props.filials.find(e => e.code === code)
            await this.loginService.login(matNumber, password, filial)
        } catch (error) {
            this.setState({ error })
        }
    }

    render = () => {
        const { error } = this.state
        return (
            <Page
                title="Login"
                hideBreadcrumb
                error={error}
                onDismissError={() => this.setState({ error: null })}
            >
                <div className="grid grid-cols-1 gap-6 md:gap-12 md:grid-cols-2">
                    <LoginCustomer {...this.props} login={this.login} />
                    <LoginCpf service={this.loginService} {...this.props} />
                </div>
            </Page>
        )
    }
}

export default Login
